import React from 'react';
import PropTypes from 'prop-types';
import { groupValidateClasses } from '../../../modules/form/utilities';

const CheckboxGroup = ({ input, label, required, meta: { touched, error }, options }) => (
  <div className={groupValidateClasses(touched, error)}>
    {label && (
      <label className={`control-label col-lg-4${required ? ' required' : ''}`}>{label}</label>
    )}
    <div className={label ? 'col-lg-8' : 'col-lg-12'}>
      {options.map((o, index) => (
        <div className="radio" key={o.key}>
          <label className={required ? ' required' : ''}>
            <input
              {...input}
              name={`${input.name}[${index}]`}
              type="checkbox"
              value={o.key}
              id={`${input.name}-${o.key}`}
              checked={input.value.includes(o.key)}
              onChange={(event) => {
                const newValue = [...input.value];
                if (event.target.checked) {
                  newValue.push(o.key);
                } else {
                  newValue.splice(newValue.indexOf(o.key), 1);
                }

                return input.onChange(newValue);
              }}
              onBlur={() => {}}
              // className={`custom-control-input ${inputValidateClasses(touched, error)}`}
            />
            {o.value}
          </label>
        </div>
      ))}
      {touched && error && <div className="form-control-feedback">{error}</div>}
    </div>
  </div>
);

CheckboxGroup.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.array,
  required: PropTypes.bool,
};

export default CheckboxGroup;
